import { render, staticRenderFns } from "./MealConfirmBtn.vue?vue&type=template&id=3801e0d0&scoped=true&"
import script from "./MealConfirmBtn.vue?vue&type=script&lang=js&"
export * from "./MealConfirmBtn.vue?vue&type=script&lang=js&"
import style0 from "./MealConfirmBtn.vue?vue&type=style&index=0&id=3801e0d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801e0d0",
  null
  
)

export default component.exports